import React from 'react';
import { Box } from 'core/components';
import { DEFAULT_ICON_SIZE } from 'core/components/Icon';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import AwsLogo from 'app/components/AwsLogo';
import AzureLogo from 'app/components/AzureLogo';
import GoogleLogo from 'app/components/GoogleLogo';
import OracleLogo from 'app/components/OracleLogo';

const CspLogoMap = {
  aws: AwsLogo,
  azure: AzureLogo,
  gcp: GoogleLogo,
  oci: OracleLogo
};

function CloudEntityIcon(props) {
  const {
    primary,
    iconSize,
    // Use this prop to make sure this component always takes up the same amount of space, regardless of if it is showing an icon or not
    fillSpaceIfNull,
    context
  } = props;

  const { model, entity: contextEntity, type: contextType } = context || {};

  const realIconSize = iconSize || DEFAULT_ICON_SIZE;
  const Fallback = fillSpaceIfNull ? <Box style={{ width: realIconSize, height: realIconSize }} /> : null;

  if (!model || !contextType) {
    return Fallback;
  }

  const { cloudProvider } = model;

  if (!cloudProvider) {
    return Fallback;
  }

  // Use the entity from context if available, otherwise fall back to contextType
  let entityType = contextEntity || contextType;

  if (cloudProvider === 'oci' && entityType === 'natGateway') {
    entityType = 'natGateways'; // OCI uses plural form for nat gateways icon
  }

  // Special case for topology_loaded contexts - always show CSP logo for these
  if (contextType === 'topology_loaded') {
    const CspLogo = CspLogoMap[cloudProvider];
    if (!CspLogo) {
      return Fallback;
    }
    return <CspLogo width={realIconSize} height={realIconSize} />;
  }

  return (
    <Box display="flex" alignItems="center" style={{ width: realIconSize, height: realIconSize }}>
      <CloudIcon
        {...props}
        iconSize={realIconSize}
        primary={primary}
        cloudProvider={cloudProvider}
        entity={entityType}
      />
    </Box>
  );
}

export default CloudEntityIcon;
